/**
 * Converte o que o usuário cola (link normal, link curto, <iframe> inteiro)
 * na URL de embed que o site monta no <iframe>. Só https. Provedores sem
 * regra própria passam como estão (o site sempre põe sandbox). O renderer
 * (Astro) tem uma cópia desta função com a MESMA tabela de testes.
 */
const YOUTUBE_ID = /^[A-Za-z0-9_-]{6,20}$/;

function youtubeEmbed(id: string | null | undefined): string | null {
  return id && YOUTUBE_ID.test(id) ? `https://www.youtube.com/embed/${id}` : null;
}

export function toEmbedUrl(input: string): string | null {
  const raw = input.trim();
  if (!raw) return null;

  const iframeSrc = raw.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
  const candidate = iframeSrc ? iframeSrc[1] : raw;

  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;

  const host = url.hostname.replace(/^(www|m)\./, '');

  if (host === 'youtu.be') {
    return youtubeEmbed(url.pathname.split('/')[1]);
  }
  if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    const embed = url.pathname.match(/^\/embed\/([^/?]+)/);
    if (embed) return youtubeEmbed(embed[1]);
    const shorts = url.pathname.match(/^\/shorts\/([^/?]+)/);
    if (shorts) return youtubeEmbed(shorts[1]);
    return youtubeEmbed(url.searchParams.get('v'));
  }
  if (host === 'vimeo.com') {
    const id = url.pathname.match(/^\/(\d+)/);
    return id ? `https://player.vimeo.com/video/${id[1]}` : null;
  }
  if (host === 'player.vimeo.com') {
    return url.href;
  }
  if (host === 'loom.com') {
    const id = url.pathname.match(/^\/(?:share|embed)\/([A-Za-z0-9]+)/);
    return id ? `https://www.loom.com/embed/${id[1]}` : null;
  }

  return url.href;
}
